module.exports = __webpack_public_path__ + "static/media/lemon.be008b3a.jpg";